import { Component } from '@angular/core';
import { APPCONFIG } from '../../config';

@Component({
  selector: 'my-app-search-overlay',
  styles: [],
  templateUrl: './search-overlay.component.html'
})

export class AppSearchOverlayComponent {

}



// WEBPACK FOOTER //
// ./src/app/layout/search-overlay/search-overlay.component.ts